import React, { FunctionComponent } from 'react';

import { withErrorBoundary } from '../../helpers/hocs/with-error-boundary';
import { usePromozavrRuntimeController } from './runtime-controller';
import { getPromozavrRuntimeRenderers } from './runtime-renderers';

import './runtime.css';

export const PromozavrRuntimeComponent: FunctionComponent = () => {
    const { PromoRenderer, promoRenderers } = usePromozavrRuntimeController();

    if (promoRenderers.length === 0) {
        return null;
    }

    const { topLinePromoRenderers, overlayPromoRenderers } = getPromozavrRuntimeRenderers(promoRenderers);

    return (
        <>
            {topLinePromoRenderers.map(({ key, props }) => (
                <PromoRenderer key={key} {...props} />
            ))}
            {overlayPromoRenderers.map(({ key, props }) => (
                <PromoRenderer key={key} {...props} />
            ))}
        </>
    );
};

export const PromozavrRuntime = withErrorBoundary(PromozavrRuntimeComponent);
